import { Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import PropTypes from 'prop-types';
import React from 'react';


const useStyles = makeStyles(theme => ({
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1)
    },
    dialogContent: {
        "& .MuiInputBase-input": {
            boxShadow: "none !important",
        }
    }
}));

/**
 * A generic component for abstracting the Material-UI Dialog modal component
 *
 * @param {function} onClose The function to call when the Dialog close is triggered
 * @param {boolean} open A boolean which toggles the Dialog being open or closed
 * @param {string} title The Title to be displayed at the top of the Dialog
 */
export default function CustomConfirmationDialog({ onClose, open, children, title, ...props }) {
    const classes = useStyles();

    return open ? (
        <Dialog
            maxWidth="sm"
            aria-labelledby="confirmation-dialog-title"
            onClose={onClose}
            open
            {...props}
        >
            <DialogTitle>
                {title}
                <IconButton
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon></CloseIcon>
                </IconButton>
            </DialogTitle>

            <DialogContent className={classes.dialogContent}>
                {children}
            </DialogContent>
            {
                /**
                 * @todo - future improvement - update existing implementations to utilize <DialogActions>
                 */
                props.actions
            }
        </Dialog>
    ) : null;
}

CustomConfirmationDialog.propTypes = {
    title: PropTypes.string,
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
